
<nav class="navbar navbar-expand navbar-dark bg-dark topbar-padding">
  <button
    class="navbar-toggler"
    type="button"
    data-bs-toggle="collapse"
    data-bs-target="#navbarNavNavigation"
    aria-controls="navbarNavNavigation"
    aria-expanded="false"
    aria-label="Toggle navigation"
  >
    <span class="navbar-toggler-icon"></span>
  </button>

  <div class="collapse navbar-collapse" id="navbarNavNavigation">
    <ul class="navbar-nav me-auto">
      @if(!isIos) {
        <li class="nav-item">
          <a class="me-2" href="{{ playStoreUrl }}">
            <img height="50" src="/assets/img/joinOnPlayStore.png" />
          </a>
        </li>
      }
      @if(!isAndroid) {
        <li class="nav-item">
          <a class="me-2" href="{{ appStoreUrl }}">
              <img height="50" src="/assets/img/joinOnAppStore.png" />
          </a>
        </li>
      }
    </ul>

    <app-language-selector></app-language-selector>
  </div>
</nav>
